import { reconciliationResultMessages } from "@/services/messages";
import { useTabActions } from "@/stores/tab-store";
import { AlertTriangle } from "lucide-react";

/**
 * Sticky-баннер устаревшего отчёта (T062, FR-021, R4).
 *
 * Рендерится поверх контента таба `reconciliation-result-${oldRunId}` после
 * `tab-store.markRunResultStale(oldRunId)`. Контент таба под ним — обёрнут
 * в `pointer-events-none opacity-60` (R4: CSS-only disable, без props-drilling).
 *
 * CTA «Открыть актуальный» активирует таб с новым runId (если уже открыт)
 * либо открывает его. Передаётся `currentSetId` чтобы найти actual run.
 */
export interface StaleOverlayProps {
	currentSetName: string;
	/** runId нового (актуального) прогона, если известен. Если null — UI должен
	 * подгрузить через GET /sets/:setId/runs (handler передаётся через onOpenActual). */
	actualRunId: string | null;
	currentSetId: number;
	onOpenActual: () => void;
}

export function StaleOverlay({
	currentSetName,
	actualRunId,
	currentSetId,
	onOpenActual,
}: StaleOverlayProps) {
	const messages = reconciliationResultMessages.stale;
	const { openReconciliationResultTab } = useTabActions();

	const handleClick = () => {
		if (actualRunId) {
			openReconciliationResultTab(currentSetId, actualRunId, currentSetName);
		} else {
			onOpenActual();
		}
	};

	return (
		<div
			role="alert"
			className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2.5 shadow-sm"
		>
			<div className="flex items-center gap-2">
				<AlertTriangle className="h-4 w-4 shrink-0 text-amber-600" aria-hidden="true" />
				<p className="text-sm font-medium text-amber-900">{messages.banner_title}</p>
			</div>
			<button
				type="button"
				onClick={handleClick}
				className="rounded-lg border border-amber-400 bg-white px-3 py-1.5 text-xs font-medium text-amber-800 transition-colors hover:bg-amber-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
			>
				{messages.open_actual_cta}
			</button>
		</div>
	);
}
